import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { MediaLenient } from "@/components/forms/schemas/media";

const disabled = fieldConfig({ inputProps: { disabled: true } });

/** UpdateLeagueCommand, curator-owned members only (LEAGUE_EDITABLE). */
export const leagueEditSchema = z.object({
  id: z.string().nullish().superRefine(disabled),
  name: z.string().min(1, "Required"),
  enabled: z.boolean().default(true),
  tier: z.coerce.number().int().min(1).nullish(),
  status: z.enum(["Draft", "Complete", "Archived"]),
  hide: z.boolean().default(false),
  media: MediaLenient.nullish().superRefine(
    fieldConfig({ fieldType: "media", customData: { collection: "Leagues" } }),
  ),
});
export type LeagueEditType = z.infer<typeof leagueEditSchema>;
